import { FC, ReactElement } from 'react';
import Link from 'next/link';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { ChallengeMode, PageInfoHeaderSkeleton, Routes } from '@whitesharx/starfall-frontend-core';
import { ChallengesSkeleton } from '@whitesharx/starfall-frontend-core/challenges_screen';
import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { InfoHeaderSkeleton } from '~/src/components/InfoHeader/InfoHeaderSkeleton';
import { linkStyles, pageTitleBlurStyles } from '~/styles/pages/common.css';

const ROUTES_BY_MODE = {
  [ChallengeMode.PUZZLE]: Routes.challengesPuzzles,
  [ChallengeMode.STORM]: Routes.challengesStorm,
};

const link = (mode: ChallengeMode) => (children: ReactElement) =>
  (
    <Link passHref href={ROUTES_BY_MODE[mode]}>
      <a className={linkStyles}>{children}</a>
    </Link>
  );

const ChallengesSkeletonPage: FC = () => (
  <PageLayoutSkeleton rightContainer={<UserInfoSkeleton />}>
    <InfoHeaderSkeleton />
    <PageInfoHeaderSkeleton title={t('challenges.page-title')} name="challenges" textClassName={pageTitleBlurStyles} />
    <ChallengesSkeleton link={link} />
  </PageLayoutSkeleton>
);

export default ChallengesSkeletonPage;
